import { type MeldingVoorkeuren, type Notification, meldingCategorie } from '@kennisbank/shared';

export const APP_TITEL = 'SUPPOHRT Kennishub';

/** Ongelezen meldingen die volgens de schakelaars mogen ploppen en meetellen. */
export function telbaar(meldingen: Notification[], v: MeldingVoorkeuren): Notification[] {
  return meldingen.filter((m) => !m.readAt && v[meldingCategorie(m.type)]);
}

/** "(3) SUPPOHRT Kennishub", zodat een ander tabblad het ook laat zien. */
export function tabTitel(aantal: number, appNaam: string = APP_TITEL): string {
  return aantal > 0 ? `(${aantal}) ${appNaam}` : appNaam;
}

/**
 * Wat er sinds de vorige poll bijkwam of opnieuw ongelezen werd. Eén strook
 * per gesprek of kanaal per pollronde volgt vanzelf uit de samenvouwing in de
 * bel: zelfde document-id, nieuwere updatedAt.
 *
 * `vorige === null` is de eerste lading na inloggen of verversen: dan plopt er
 * niets, anders krijg je bij elke paginaverversing de hele achterstand.
 */
export function nieuweMeldingen(
  vorige: Notification[] | null,
  huidige: Notification[],
  v: MeldingVoorkeuren,
  pathname: string,
): Notification[] {
  if (vorige === null) return [];
  const bekend = new Map(vorige.map((m) => [m.id, m.updatedAt]));
  return telbaar(huidige, v).filter((m) => {
    const eerder = bekend.get(m.id);
    if (eerder !== undefined && eerder >= m.updatedAt) return false;
    // Je zit er al: geen strook voor de pagina waar je naar kijkt.
    return m.link !== pathname;
  });
}
